module.exports = __webpack_public_path__ + "static/media/circle-grey.c1b17f4d.svg";